import { createMutableAction, IBaseMutableAction, IDictionary } from '@bimser/core';
import * as ActionTypes from '../actionTypes';

export function changeChangesRows(
	rowChanges: IDictionary<any>
): IBaseMutableAction<IDictionary<any>> {
	return createMutableAction(ActionTypes.CHANGE_EDITING_CHANGES_ROWS, rowChanges);
}
